import { render, staticRenderFns } from "./VerticalsFilter.vue?vue&type=template&id=5d458eae&scoped=true"
import script from "./VerticalsFilter.vue?vue&type=script&lang=ts"
export * from "./VerticalsFilter.vue?vue&type=script&lang=ts"
import style0 from "./VerticalsFilter.vue?vue&type=style&index=0&id=5d458eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d458eae",
  null
  
)

export default component.exports